<template lang="pug">
.v-about.about(v-if="about")
	.about__container.container
		v-title.about__title-wrapper(v-if="about.pageTitle" :title="about.pageTitle")
		.about__wrap
			.about__left
				img.about__left-img(v-if="about.image"
						:src="about.image"
						alt=""
						loading="lazy")
				.about__left-wrap
					.about__left-text
						.about__text-title(v-if="about.title") {{about.title}}
						.about__text-main(v-if="about.text") {{about.text}}
					a.about__left-btn.btn.btn--white(v-if="about.btn"
							:class="about.btn.classNames || ''"
							:href="about.btn.link")
						| {{about.btn.text}}
			.about__right
				template(v-if="about.items && about.items.length"
						v-for="(item, itemIndex) in about.items"
						:key="itemIndex")
					.about__right-item
						img.about__right-image(v-if="item.image"
								:src="item.image"
								alt=""
								loading="lazy")
						.about__right-title(v-if="item.title") {{item.title}}
						.about__right-text(v-if="item.text") {{item.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			about: null
		};
	},

	methods: {
		dataSet(data) {
			this.about = data;
		},

		goBack() {
			window.history.back();
		},
	}
};
</script>